import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { RegionCascader as LocalRegionCascader } from '../../components/RegionCascader'

export const RegionCascader = connect(
  LocalRegionCascader,
  mapReadPretty(LocalRegionCascader, {
    disabled: true
  })
)
